import {Configuration, FilesApi, InstrumentsApi, PsychometricApi, TagsApi} from "../gen/api";

function getConfiguration() {
  return new Configuration({
    basePath: process.env.REACT_APP_COVCHILD_CONTROL_URL,
    username: localStorage.getItem("user") || "",
    password: localStorage.getItem("password") || ""
  });
}

export var instrumentsApi = new InstrumentsApi(getConfiguration());
export var tagsApi = new TagsApi(getConfiguration());
export var fileApi = new FilesApi(getConfiguration());
export var psychometricApi = new PsychometricApi(getConfiguration());

export const updateApisWithBasicAuth = () => {
  instrumentsApi = new InstrumentsApi(getConfiguration());
  tagsApi = new TagsApi(getConfiguration());
  fileApi = new FilesApi(getConfiguration());
  psychometricApi = new PsychometricApi(getConfiguration());
}